export default __webpack_public_path__ + "static/media/projectThumb2.47e764be.png";